import { Col, Row } from "antd";
import React from "react";
import { Texts } from "../DetailTab";
import { dateFormatter, numberFormatter } from "../../../../../utility/Formatter";
import { color, icon } from "../../../../../resource";
import styled from "styled-components";
import Text from "../../../../../components/Text/Text";
import Button from "../../../../../components/Button/Button";
import { EstimatePointFormatter } from "../../../../../utility/EstimatePointFormatter";
import type { PointDetailEntity } from "../../../../../entities/PointApproveEntity";

interface Props {
  data: PointDetailEntity;
}
function DetailDL({ data }: Props) {
  return (
    <div>
      <Row gutter={[16, 16]} style={{ marginBottom: 12 }}>
        <Col xs={24} sm={12} md={12} lg={12}>
          <Row gutter={[0, 12]} style={{ marginBottom: 10 }}>
            <Col span={10}>
              <Texts>เลขที่คำสั่งซื้อ :</Texts>
            </Col>
            <Col span={14} style={{ display: "flex", alignItems: "center" }}>
              <Texts style={{ marginRight: 8 }}>{data?.orderPointCode}</Texts>
              <Texts style={{ color: color.placeholder }}>{`(${dateFormatter(
                data.dateDelivery,
                true,
              )})`}</Texts>
            </Col>
          </Row>
          <Row gutter={[0, 12]} style={{ marginBottom: 10 }}>
            <Col span={10}>
              <Texts>เลขที่ใบสั่งขาย (SO) :</Texts>
            </Col>
            <Col span={14}>
              <Texts>{data.soNo || "-"}</Texts>
            </Col>
          </Row>
          <Row gutter={[0, 12]}>
            <Col span={10}>
              <Texts>เลขที่ใบส่งของ (PDO) :</Texts>
            </Col>
            <Col span={14}>
              <Texts>{data.pdoNo || "-"}</Texts>
            </Col>
          </Row>
        </Col>

        <Col xs={24} sm={12} md={12} lg={12}>
          <Row gutter={[0, 12]} style={{ marginBottom: 10 }}>
            <Col span={12}>
              <Texts>ร้าน Dealer :</Texts>
            </Col>
            <Col span={12}>
              <Texts>{data.dealerName}</Texts>
              <Texts style={{ color: color.placeholder }}>
                {data.dealerNo} {data.dealerNo || data.dealerZone ? "•" : "-"} {data.dealerZone}
              </Texts>
            </Col>
          </Row>
          <Row gutter={[0, 12]} style={{ marginBottom: 10 }}>
            <Col span={12}>
              <Texts>ยอดแต้มที่ได้รับ :</Texts>
            </Col>
            <Col span={12}>
              <Texts>
                <EstimatePointFormatter historyOrderPoint={data.historyOrderPoint} page='detail' />
                &nbsp;
                {numberFormatter(data.sumPoint, 2)} แต้ม
              </Texts>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default DetailDL;
